export const ACCIDENT_REPORTING_OPTIONS = [
  {
    type: 'rps',
    label: 'RPS'
  },
  {
    type: 'client',
    label: 'Klient'
  },
  {
    type: 'service',
    label: 'Servis'
  }
];

export const ACCIDENT_SOURCE_TYPE = {
  TIP: 'tip',
  INSURANCE: 'insurance',
  SERVICE: 'service'
};
